let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iTdzs")).then(() => parcelRequire('4iDME'));